var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{},[(_vm.items[0])?_c('v-chip',{attrs:{"label":"","outlined":"","color":"blue darken-4"}},[_vm._v(" "+_vm._s(_vm.dateItems.join(' --- '))+" ")]):_c('v-chip',{attrs:{"label":"","outlined":"","color":"blue darken-1"}},[_vm._v(" "+_vm._s(_vm.$t('page.report.without_timeframe_chip'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }